import script from "./SelectPackage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectPackage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectPackage.vue?vue&type=style&index=0&id=477a3bde&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477a3bde"]])

export default __exports__